import React from 'react'
import { Stack } from '~/components/_layouts'
import { ActionPlanCard } from '../cards/ActionPlanCard'
import { MyJobsCard } from '../cards/MyJobsCard'
import { AylaCard } from '../cards/AylaCard'
import { AylaCardBig } from '../cards/AylaCardBig'
import { RecommendedJobsCard } from '../cards/RecommendedJobsCard'
import { RecommendedBlogsCard } from '../cards/RecommendedBlogsCard'
import { RecommendedBoardsCard } from '../cards/RecommendedBoardsCard'
import { RecommendedCard } from '../cards/RecommendedCard'

export function Solo({ current_user }) {
  return (
    <Stack spacing={8}>
      <div className="grid gap-8 xl:grid-cols-[1fr_1fr] 2xl:grid-cols-[4fr_3fr_3fr]">
        <ActionPlanCard className="action-plan-card xl:col-span-2 2xl:col-span-1" />
        <MyJobsCard className="my-jobs-card" />
        {current_user?.intoo_uk ? (
          <RecommendedBoardsCard className="recommended-boards" />
        ) : (
          <AylaCard className="ayla-card" />
        )}
      </div>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1fr]">
        <RecommendedJobsCard className="recommended-jobs" />
        {current_user?.intoo_uk ? (
          <AylaCardBig />
        ) : (
          <RecommendedBlogsCard className="recommended-blogs" />
        )}
      </div>
      <RecommendedCard />
    </Stack>
  )
}
